var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M11 20a9 9 0 1 1 0-18 9 9 0 0 1 0 18m-1.394-6.883L7.056 9.18l-1.679 1.087 4.21 6.503 6.81-10.286-1.667-1.104z"}));
}

Checkmark.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
